module.exports = __webpack_public_path__ + "img/background_invite_a_friend.394bb474.svg";